<div *ngIf="isExist(calibrationUsesLabels)">
    <label>Uses</label>
    <div class="content" *ngFor="let usesLabel of calibrationUsesLabels | keyvalue">
        <label>{{getTypeNameById(usesLabel.key)}}</label>
        <div class="table">
            <div class="column-title">
                <div class="table-row" *ngFor="let row of usesRow; first as isFirst">
                    <div [class.first-table-row]="isFirst">{{row}}</div>
                </div>
            </div>
            <div class="table-body">
                <div *ngFor="let field of usesLabel.value" class="table-row">
                    <div class="fixed-width-field"> {{field?.Label}} </div>
                    <div> {{getCalibrationStatusType(field?.diffStatus)}} </div>
                </div>
            </div>
        </div>
    </div>
</div>
